module.exports = __webpack_public_path__ + "img/HC1014-25.89fbc4c7.jpg";